import Slot, {SLOT_PAYMENT_STATUS_FREE} from "../../../../entities/Slot";
import patch from "../../../patch";

export const disAppoint = (slot: Slot) =>
    patch(
      `slots/${slot.id}`,
      {
        state: SLOT_PAYMENT_STATUS_FREE,
      });